import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
   private readonly loading = signal(false);
   private readonly message = signal<string | null>(null);

   readonly isLoading = this.loading.asReadonly();
   readonly loadingMessage = this.message.asReadonly();

   show(message?: string): void {
      this.message.set(message ?? null);
      this.loading.set(true);
   }

   hide(): void {
      this.loading.set(false);
      this.message.set(null);
   }
}
